import { 
  Insights as InsightsIcon,
  Widgets,
  Inventory,
  Science,
  Analytics,
  BugReport,
  Settings,
  Assessment
} from '@mui/icons-material';
import mymaIcon from '../assets/images/myma-icon.svg';
import Insights, { PerformanceTab as InsightsPerformanceTab } from '../pages/Insights/Insights';
import Diagnostics, { ProblemsTab as DiagnosticsProblemsTab, AlertsTab as DiagnosticsAlertsTab } from '../pages/Diagnostics/Diagnostics';
import Machines, { OverviewTab as MachinesOverviewTab, POSAnalysisTab } from '../pages/Machines/Machines';
import AnalysisPage, { PointOfSalesTab } from '../pages/Analysis/Analysis';
import Products, { OverviewTab as ProductsOverviewTab } from '../pages/Products/Products';
import ExperimentManagement, { ExperimentsTab, AlertsTab } from '../pages/ExperimentManagement/ExperimentManagement';
import ExperimentsOverview, { OverviewTab as ExperimentsOverviewOverviewTab } from '../pages/ExperimentsOverview/ExperimentsOverview';
import SettingsPage, { ProductsTab as SettingsProductsTab, ClientsTab as SettingsClientsTab, CostRulesTab as SettingsCostRulesTab } from '../pages/Settings/Settings';

export const navigationConfig = [
  {
    id: 'insights',
    title: 'Insights',
    titleKey: 'insights',
    path: '/insights',
    icon: InsightsIcon,
    tabs: [
      { label: 'Performance', component: InsightsPerformanceTab },
    ],
    component: Insights
  },
  {
    id: 'diagnostics',
    title: 'Diagnostics',
    titleKey: 'diagnostics',
    path: '/diagnostics',
    icon: BugReport,
    tabs: [
      { label: 'Problems & Experiments', labelKey: 'problemsExperiments', slug: 'problems', component: DiagnosticsProblemsTab },
      { label: 'Alerts', labelKey: 'alerts', slug: 'alerts', component: DiagnosticsAlertsTab }
    ],
    component: Diagnostics
  },
  {
    id: 'experiments',
    title: 'Experiment Management',
    titleKey: 'experimentManagement',
    path: '/experiments',
    icon: Science,
    tabs: [
      { label: 'Overview', labelKey: 'overview', slug: 'overview', component: ExperimentsTab },
      { label: 'Alerts', labelKey: 'alerts', slug: 'alerts', component: AlertsTab }
    ],
    component: ExperimentManagement
  },
  {
    id: 'experiments-overview',
    title: 'Experiments Overview',
    titleKey: 'experimentsOverview',
    path: '/experiments-overview',
    icon: Analytics,
    tabs: [
      { label: 'Overview', component: ExperimentsOverviewOverviewTab }
    ],
    component: ExperimentsOverview
  },
  {
    id: 'machines',
    title: 'Machine',
    titleKey: 'sidebar_pointOfSales',
    path: '/machines',
    icon: Widgets,
    tabs: [
      { label: 'Ubicación y Sector', labelKey: 'posAnalysis', slug: 'pos-analysis', component: POSAnalysisTab },
      { label: 'Planograma', labelKey: 'planograma', slug: 'planogram', component: MachinesOverviewTab }
    ],
    component: Machines
  },
  // {
  //   id: 'analysis',
  //   title: 'Analysis',
  //   titleKey: 'analysis',
  //   path: '/analysis',
  //   icon: Assessment,
  //   tabs: [
  //     { label: 'Point of Sales', labelKey: 'pointOfSales', component: PointOfSalesTab }
  //   ],
  //   component: AnalysisPage
  // },
  // {
  //   id: 'products',
  //   title: 'Products',
  //   titleKey: 'products',
  //   path: '/products',
  //   icon: Inventory,
  //   tabs: [
  //     { label: 'Overview', component: ProductsOverviewTab }
  //   ],
  //   component: Products
  // }
];

export const bottomNavigationConfig = [
  {
    id: 'settings',
    titleKey: 'settings',
    path: '/settings',
    icon: Settings,
    tabs: [
      { label: 'Products', labelKey: 'products', slug: 'products', component: SettingsProductsTab },
      { label: 'Clients', labelKey: 'clients', slug: 'clients', component: SettingsClientsTab },
      { label: 'Cost rules', labelKey: 'costRules', slug: 'cost-rules', component: SettingsCostRulesTab }
    ],
    component: SettingsPage
  },
  {
    id: 'preview',
    title: 'Myma Preview',
    path: '/preview',
    icon: mymaIcon,
    isAvatar: true
  }
]; 
